import React, { FC } from "react";
import { Box, Typography } from "@mui/material";
import { FormikValues, useFormikContext } from "formik";
import FormDropdownField from "../../../common/Form/Dropdown/FormDropdownField";
import InputField from "../../../common/Form/Input/InputField";

import {
  useGetAllIrbSubmissionsQuery,
  useGetIrbSubmissionInfoLazyQuery,
  useGetProtocolListQuery,
} from "../../../../generated/graphql";
import { EC_SUBMISSION_TYPES, SUBMISSION_TYPES } from "../../../../constants";
import {
  DATE_OF_EVENT,
  DEPARTMENT,
  MICR,
  PRINCIPAL_INVESTIGATOR,
  PROTOCOL_NUMBER,
  SPONSOR,
  TITLE,
} from "../../../../constants/forms";

const StudyDetailsPvpd: FC = (): JSX.Element => {
  const { values, setFieldValue, setValues } = useFormikContext<FormikValues>();
  // const { data } = useGetAllIrbSubmissionsQuery();
  const { data, loading, error } = useGetProtocolListQuery({
    variables: {
      subType: EC_SUBMISSION_TYPES.PVPD_DETAILS,
      submissionType: SUBMISSION_TYPES.EC,
    },
  });
  const protocolNumbers = data?.getProtocolList.map((item, i) => {
    return item.protocolNumber;
  });
  let id: string;
  const getIdFromValue = (number: string) => {
    data?.getProtocolList.forEach((item, i) => {
      if (item.protocolNumber === number) {
        id = item._id;
      }
    });
    return id;
  };
  const [getIrbById] = useGetIrbSubmissionInfoLazyQuery();
  const dropdownInputHandlerPN = async (fieldName: string, value: any) => {
    const id = getIdFromValue(value);
    const newValues = await getDataFromProtocolNumber(id);
    setValues({
      ...newValues,
      [fieldName]: value,
    });
  };

  const getDataFromProtocolNumber = async (id: string) => {
    const { data } = await getIrbById({
      variables: { id },
    });
    if (data) {
      const {
        department,
        principalInvestigator,
        sponsor,
        studyPhase,
        title,
        typeOfStudy,
        micr,
        documents,
        ...rest
      } = data.irb;
      return {
        ...values,
        department,
        principalInvestigator,
        typeOfStudy,
        sponsor,
        studyPhase,
        title,
        micr,
        ...rest
      };
    }
    return values;
  };

  return (
    <>
      <FormDropdownField
        label=" 1.1 Protocol Number/Short Title"
        value={values[PROTOCOL_NUMBER]}
        name={PROTOCOL_NUMBER}
        options={protocolNumbers} //make this dynamic
        inputHandler={dropdownInputHandlerPN}
        // disabled={!!id}
      />
      {/* <InputField
        label={"1.2 MICR #"}
        name={MICR}
        placeholder={"Short Text"}
        value={values[MICR]}
        // disabled={!!id}
      /> */}
      <Box className="mg-b-50">
        <label className="form-label mg-b-20 font-size-14">1.2 MICR #</label>
        <Typography variant={"body1"} component={"h3"} color={"secondary"}>
          {values[MICR]}
        </Typography>
      </Box>
      <Box className="mg-b-50">
        <label className="form-label mg-b-20 font-size-14">
          1.3 Study Title
        </label>
        <Typography variant={"body1"} component={"h3"} color={"secondary"}>
          {values[TITLE]}
        </Typography>
      </Box>
      <Box className="mg-b-50">
        <label className="form-label mg-b-20 font-size-14">1.4 Sponsor</label>
        <Typography variant={"body1"} component={"h3"} color={"secondary"}>
          {values[SPONSOR]}
        </Typography>
      </Box>
      <Box className="mg-b-50">
        <label className="form-label mg-b-20 font-size-14">
          1.5 Principal Investigator
        </label>
        <Typography variant={"body1"} component={"h3"} color={"secondary"}>
          {values[PRINCIPAL_INVESTIGATOR]}
        </Typography>
      </Box>
      <Box className="mg-b-50">
        <label className="form-label mg-b-20 font-size-14">
          1.6 Department
        </label>
        <Typography variant={"body1"} component={"h3"} color={"secondary"}>
          {values[DEPARTMENT]}
        </Typography>
      </Box>
      <InputField
        label={"1.7  Date of Event"}
        name={DATE_OF_EVENT}
        placeholder={"Enter date of Event"}
        type="date"
      />
    </>
  );
};

export default StudyDetailsPvpd;
